import { Component, Inject, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-auto-suggest-promo',
  templateUrl: './auto-suggest-promo.component.html',
  styleUrls: ['./auto-suggest-promo.component.scss']
})
export class AutoSuggestPromoComponent implements OnInit {
  title: string;
  promoList: [] = [];
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public _data: any,
    public _bottomSheetRef: MatBottomSheetRef<AutoSuggestPromoComponent>
  ) { }

  ngOnInit(): void {
    this.title = this._data.title;
    this.promoList = this._data.promoList;
  }


  // openLink(event: MouseEvent): void {
  //   this._bottomSheetRef.dismiss();
  //   event.preventDefault();
  // }

  onClose(event: MouseEvent, item) {
    this._bottomSheetRef.dismiss(item)
    event.preventDefault();
  }
}
